import { render } from "./TSAView.vue?vue&type=template&id=7d4ba18f&scoped=true"
import script from "./TSAView.vue?vue&type=script&lang=js"
export * from "./TSAView.vue?vue&type=script&lang=js"

import "./TSAView.vue?vue&type=style&index=0&id=7d4ba18f&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7d4ba18f"]])

export default __exports__